import React, { useMemo } from 'react';
import { FiFileText } from 'react-icons/fi';
import { RiSparklingFill } from 'react-icons/ri';
import AmpChatContainer from '../amps/AmpChatContainer';
import { useDocumentPanel } from '../../context/DocumentPanelContext';
import { useAmpsLoaded } from '../../context/AmpContext';
import '../../styles/TruckingAppetite.css';
const TruckingAppetitePage: React.FC = () => {
    const { showDocPanel, openDocPanel, closeDocPanel } = useDocumentPanel();
    const { premadeAmps } = useAmpsLoaded();
    const ampId = useMemo(() => premadeAmps.find(a => a.category === 'Trucking Market Appetite')?.id, [premadeAmps]);
    return (<div className="ta-page">
      <div className="ta-page__header">
        <div className="ta-page__header-left">
          <div className="ta-page__header-icon">
            <RiSparklingFill size={20}/>
          </div>
          <div>
            <h1 className="ta-page__header-title">Trucking Market Appetite</h1>
            <p className="ta-page__header-subtitle">Analyze and understand trucking insurance offerings with AI.</p>
          </div>
        </div>
        <button className="ta-page__header-btn" onClick={showDocPanel ? closeDocPanel : openDocPanel}>
          <FiFileText size={14}/>
          Documents
        </button>
      </div>
      <div className="ta-page__chat">
        <AmpChatContainer ampIdOverride={ampId} basePath="/trucking-appetite"/>
      </div>
    </div>);
};
export default TruckingAppetitePage;
